export const NAVBAR_OPENED = Symbol('isNavbarOpened')
export const IS_DISRUPTION_MESSAGE_VISIBLE = Symbol('isDisruptionMessageVisible')
